import React, { useContext, useEffect } from "react";
import { Check, ArrowRight } from "lucide-react";

import { AuthContext, IntlContext } from "context";
import { Button } from "components/ui/button";

type Props = {
    onClearDraft?: () => void;
};

const Welcome: React.FC<Props> = ({ onClearDraft }) => {
    const { account } = useContext(AuthContext);
    const intl = useContext(IntlContext);

    useEffect(() => {
        onClearDraft?.();
    }, [onClearDraft]);

    const goToAccount = () => {
        window.location.assign(account?.user?.roles?.includes("provider") ? "/mon-compte/profil/" : "/mon-compte/");
    };

    return (
        <div className="flex min-h-[520px] items-center justify-center">
            <div className="mx-auto w-full max-w-xl px-2 text-center">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-sm">
                    <Check className="h-7 w-7" />
                </div>

                <h2 className="mt-6 text-3xl font-black tracking-tight">{intl.formatMessage("authentication.register.label.employer.confirmed")}</h2>
                <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
                    {intl.formatMessage("authentication.register.label.send_mail")} {intl.formatMessage("authentication.register.label.ad")}
                </p>

                <Button onClick={goToAccount} className="mt-10 h-11 rounded-full px-8 shadow-md shadow-primary/20">
                    {intl.formatMessage("authentication.register.label.access_account")}
                    <ArrowRight className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
};

export default Welcome;
